<div class="ca-chip" [class.selected]="selected">
  @if (icon) {
    <mat-icon>{{ icon }}</mat-icon>
  }
  <span class="label">{{ label }}</span>
</div>
